import { Box, Chip, Skeleton, Tooltip, Typography } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { formatCurrency, formatDateDisplay } from '../utils/directDebitIcbcUtils';

const DirectDebitIcbcAnalysis = ({
  analysis,
  isLoading,
  selectedDueDate,
  selectedPeriodMonth,
  selectedPeriodYear,
  onSelectAnalysisDate,
}) => {
  const items = analysis?.items || [];

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} variant="rounded" width={230} height={32} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
        Vencimientos pendientes para débito
      </Typography>

      {items.length > 0 ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1, maxHeight: 122, overflowY: 'auto' }}>
          {items.map((item) => {
            const isSelected =
              selectedDueDate === item.due_date &&
              item.period_month === selectedPeriodMonth &&
              item.period_year === selectedPeriodYear;
            const invalidCbuText = item.invalid_cbu_count
              ? ` · ${item.invalid_cbu_count} con CBU inválido`
              : '';

            return (
              <Tooltip
                key={`${item.due_date}-${item.due_number}-${item.period_month}-${item.period_year}`}
                title={`${item.reference} · ${formatCurrency(item.total_amount)}${invalidCbuText}`}
              >
                <Chip
                  icon={<EventAvailableIcon fontSize="small" />}
                  label={`${formatDateDisplay(item.due_date)} · ${item.coupon_count} cup. · ${item.due_label}`}
                  color={isSelected ? 'primary' : 'default'}
                  variant={isSelected ? 'filled' : 'outlined'}
                  onClick={() => onSelectAnalysisDate(item)}
                  sx={{
                    borderRadius: 1,
                    fontWeight: 600,
                    '& .MuiChip-label': {
                      maxWidth: { xs: 230, md: 280 },
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                />
              </Tooltip>
            );
          })}
        </Box>
      ) : (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
          No hay vencimientos futuros con cupones impagos adheridos a débito directo.
        </Typography>
      )}
    </Box>
  );
};

export default DirectDebitIcbcAnalysis;
